import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import Seo from "@/components/Seo";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser, refreshFavorites } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post(
          "/auth/google/session",
          {},
          { headers: { "X-Session-ID": sessionId } }
        );
        setUser(data);
        await refreshFavorites();
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: data } });
      } catch (e) {
        const detail = e?.response?.status === 403 && e.response?.data?.detail;
        setError(detail || "Sign-in failed. Please try again.");
        setTimeout(() => navigate("/", { replace: true }), detail ? 5000 : 1800);
      }
    })();
  }, [location.hash, navigate, setUser, refreshFavorites]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background">
      <Seo title="Signing you in" />
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
      <p className="font-serif text-2xl text-foreground">
        {error || "Opening the conversation\u2026"}
      </p>
    </div>
  );
}
